import styled from "@emotion/styled";

export const SoundtrackForm = styled.form`
  transition: 0.5s;
`;

export const ContentWrapper = styled.div`
  margin-top: 30px;
`;
